import React from 'react';
import { SectionHeading } from './SectionHeading';
export function HookSection() {
  return <section className="w-full bg-carbon-900 py-16 sm:py-20 lg:py-28" aria-labelledby="hook-heading" data-id="element-150" data-mp="7ivqlvjt6bt6">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-151" data-mp="m68ehqx38tmq">
        <SectionHeading id="hook-heading" eyebrow="Sound familiar?" title={<>
              Still scrolling Instagram on Sunday night
              <span className="block text-mint" data-id="element-153" data-mp="3pq32c5z260xk">to find Monday’s drills?</span>
            </>} subtitle="Different athletes, different goals — same three warm-ups, every single week." data-id="element-152" data-mp="h86soy8a2g7k" />

        <p className="mx-auto mt-10 max-w-2xl border-t border-carbon-line pt-8 text-center font-display text-xl uppercase leading-snug text-paper sm:mt-12 sm:pt-10 sm:text-3xl" data-id="element-154" data-mp="3un35a80m2nkg">
          It’s not that you aren’t a great coach.
          <span className="block text-mint" data-id="element-155" data-mp="19xm6twv8op7p">It’s that you don’t have a system.</span>
        </p>
      </div>
    </section>;
}